import { frontendDomain } from '../../../../utility'
import tour from '../../../../assets/image/cube/tiles/tour.webp'
import politik from '../../../../assets/image/cube/tiles/Underconstruction-03.webp'
import briefwahl from '../../../../assets/image/cube/tiles/06-Briefwahl.webp'
import { ItemList, ItemType } from '../../../UI/Cube/types'
import olaf from '../../../../assets/image/cube/tiles/01-Olaf.webp'
import tinder from '../../../../assets/image/cube/tiles/04-Tinder.webp'
import kandiOverview from '../../../../assets/image/cube/tiles/Underconstruction-07.webp'

const homeItems: ItemList = [
  {
    type: ItemType.IMAGE,
    src: briefwahl,
    link: 'https://briefwahl.spd.de/?utm_source=qr&utm_medium=cube&utm_campaign=btw25',
    openExternal: true,
  },

  {
    type: ItemType.IMAGE,
    src: tour,
    link: 'https://olaf-scholz.spd.de/tour?utm_source=qr&utm_medium=cube&utm_campaign=btw25',
    openExternal: true,
  },
  {
    type: ItemType.IMAGE,
    src: olaf,
    link: '/olaf',
  },
  {
    type: ItemType.IMAGE,
    src: kandiOverview,
    link: `https://kandidierende.spd.de/`,
  },
  {
    type: ItemType.IMAGE,
    src: politik,
    link: `${frontendDomain}/programm`,
  },
  {
    type: ItemType.IMAGE,
    src: tinder,
    link: `https://kandidierende.spd.de/dein-programm/`,
    openExternal: true,
  },
]

export default homeItems
